import { History } from 'history';
import { useHistory } from 'react-router-dom';
import Button from '../../components/common/buttons/Button';
import GameWrapper from '../../components/common/wrappers/GameWrapper';
import PageWrapper from '../../components/common/wrappers/PageWrapper';

type LocationStateGameSelect = {
    gameCode: string;
    newDevice?: boolean;
};

type Props = History<LocationStateGameSelect> & {
    location: Location;
};

export default function GameInProgress(props: Props) {
    const history = useHistory();

    const onClick = () => {
        history.push({
            pathname: '/game-select',
            state: { gameCode: props.location?.state?.gameCode, newDevice: true },
        });
    };

    return (
        <PageWrapper>
            <div className="error-screen">
                <GameWrapper>
                    <div className="card game-card">
                        <div className="task-title">Upozornění</div>
                        <div className="task-text task-text--standalone contact-link">
                            Do této hry jste se již dříve přihlásili. Pokud jste ste připojili ke hře z nového zařízení
                            a chcete pokračovat ve hře, klikněte na tlačítko níže. Již nebude možné pokračovat ve hře na
                            původním zařízení.
                        </div>
                        <div className="task-text task-text--standalone contact-link">
                            Pokud jste ste připojili ze stejného zařízení jako předtím, klikněte na tlačítko níže.
                        </div>
                        <div className="home-link">
                            <Button onClick={onClick} className="primary-button">
                                Potvrdit
                            </Button>
                        </div>
                    </div>
                </GameWrapper>
            </div>
        </PageWrapper>
    );
}
